import {
  getWhiteLabelLogoHeightScale,
  getWhiteLabelLogoUrl,
  usesCustomLogo,
} from "../../config/white-label";
import { ReactComponent as Logo } from "../../assets/logo.svg";

export default function AppLogo({ height = 42, width = 38, style, onClick }) {
  const customLogoUrl = getWhiteLabelLogoUrl();

  if (usesCustomLogo() && customLogoUrl) {
    const scale = getWhiteLabelLogoHeightScale();

    return (
      <img
        src={customLogoUrl}
        alt="Logo"
        onClick={onClick}
        style={{
          display: "block",
          maxHeight: height,
          width: "auto",
          height: "auto",
          objectFit: "contain",
          flexShrink: 0,
          ...(scale !== 1
            ? {
                transform: `scale(${scale})`,
                transformOrigin: "left center",
              }
            : undefined),
          ...style,
        }}
      />
    );
  }

  return <Logo height={height} width={width} style={style} onClick={onClick} />;
}
